import { Avatar, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { GrayPerson, LogoSmall } from 'Images';

interface IIconAndText {
  isUsersText: boolean;
  title: string;
  text: string;
  amount?: string;
}

export const IconAndText = ({
  isUsersText,
  title,
  text,
  amount,
}: IIconAndText) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap='8px'
      direction='row'
      padding={isDesktop ? '16px 21px 18px 16px' : '16px 12px 16px 22px'}
    >
      <Avatar
        src={isUsersText ? GrayPerson : LogoSmall}
        alt={''}
        sx={{ width: '28px', height: '28px' }}
      />
      <Stack pt='3px' gap='9px'>
        <Typography variant={'body4'}>{title}</Typography>
        <Typography variant={'body3'}>
          {text}
          {amount && (
            <Typography variant={'body3'} sx={{ color: '#00851d' }}>
              {amount}
            </Typography>
          )}
        </Typography>
      </Stack>
    </Stack>
  );
};
